// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[class*='tgr-container'] {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 auto;
    width: 100%;
}

.tgr-container {
    max-width: 100%;
    padding: 0 24px;
}

@media screen and (min-width: 768px) {
    .tgr-container {
        max-width: 1440px;
        padding: 0 40px;
    }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-web-core/dist/grid/container.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":["[class*='tgr-container'] {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.tgr-container {\n    max-width: 100%;\n    padding: 0 24px;\n}\n\n@media screen and (min-width: 768px) {\n    .tgr-container {\n        max-width: 1440px;\n        padding: 0 40px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
